import { Button, ButtonProps } from '@mui/material';
import { darken, lighten } from 'polished';
import React from 'react';
import styled from 'styled-components';

interface Props extends ButtonProps {
  background: string;
  highlight: string;
  $buttonColor: string;
  fontFamily?: string;
  width?: string;
}

const Styled = styled(Button)<Props>`
  &.MuiButton-root {
    border-radius: 12px;
    background-color: ${(props: Props) => props.background};
    color: ${(props: Props) => props.$buttonColor};
    border-color: ${(props: Props) => darken(0.1, props.background)};
    font-family: 'Open Sans';

    &.Mui-disabled {
      background: grey;
    }

    :hover {
      color: ${(props: Props) => props.$buttonColor};
      background-color: ${(props: Props) => lighten(0.1, props.background)};
      border-color: ${(props: Props) => darken(0.1, props.highlight)};
    }

    :focus {
      border-color: ${(props: Props) => darken(0.1, props.background)};
    }

    &.continue-button {
      border-radius: 40px;
      margin-bottom: 16px;
      margin-top: 16px;

      @media (max-width: 1024px) {
        width: ${(props: Props) => props.width ?? 'calc(100% - 6rem)'};
      }
    }

    &.modal-button {
      width: 100%;
    }

    @media (min-width: 1024px) {
      width: ${(props: Props) => props.width ?? '90px'};
    }
  }
`;

export const StyledButton: React.FC<Props> = ({ children, ...props }) => {
  //console.log('BUTTON PROPS: ', props);
  return <Styled {...props}>{children}</Styled>;
};
